import { UntypedFormGroup, ValidatorFn } from '@angular/forms'

export function requireCommentOnOpenSelection(formControlName: string, commentsControlName: string, openStatementKeys: string[]): ValidatorFn {
  return function validate(formGroup: UntypedFormGroup) {
    const selectedValues = formGroup.get(formControlName).value

    for (const field in selectedValues) {
      if (selectedValues[field] && openStatementKeys.includes(field)) {
        const comment = formGroup.get(commentsControlName).get(field).value
        if (!comment) {
          return {
            requireNonEmptyComment: true
          }
        }
      }
    }

    return null
  }
}
